import api from "./api";

// Fetch all commissions
export const fetchCommissions = async () => {
  try {
    const response = await api.get('/driver-commission-management/commissions');
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error fetching commissions:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to fetch commissions" };
  }
};

// Create a new commission (PUT request)
export const createCommission = async (commissionData) => {
  try {
    const response = await api.post('/driver-commission-management/commissions', commissionData);
    if (response.status === 200) {
      return response.data; 
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error creating commission:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to create commission" };
  }
};

// Update a specific commission (PUT request with commission ID)
export const updateCommission = async (commissionId, commissionData) => {
  try {
    const response = await api.put(`/driver-commission-management/commissions/${commissionId}`, commissionData);
    if (response.status === 200) {
      return response.data; 
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error updating commission:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to update commission" };
  }
};

// Delete a commission (DELETE request with commission ID)
export const deleteCommission = async (commissionId) => {
  try {
    const response = await api.delete(`/driver-commission-management/commissions/${commissionId}`);
    if (response.status === 200) {
      return response.data;
    } else {
      console.warn("Unexpected Response:", response);
      return { error: "Unexpected response from server" };
    }
  } catch (error) {
    console.error("Error deleting commission:", error.message || error);
    return { error: error.response?.data?.detail || error.message || "Failed to delete commission" };
  }
};
